/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { DeleteNotification } from "../../../../redux/features/notifications/notificationActions";
import { successMessage } from "../../../../utlis/common";
import ThreeDotsIcon from "../../../../../_metronic/assets/images/ThreeDotsIcon";
import { KTIcon } from "../../../../../_metronic/helpers/components/KTIcon";
import { conFirmMessage } from "../../../../utlis/shared";
import { toAbsoluteUrl } from "../../../../../_metronic/helpers";
import { DeleteInvoice, FetchInvoiceDocuments } from "../../../../redux/features/invoice/invoiceAction";
import {  setOpenDocumentUploadModal, setOpenEditInvoiceModal, setOpenInvoiceListModal } from "../../../../redux/features/invoice/invoiceSlice";
import { setOpenOrderListModal } from "../../../../redux/features/dashboard/dashboardSlice";

type Props = {
  user: any;
  isModalContext?: boolean;
};

const ActionCell: FC<Props> = ({ user, isModalContext = false }) => {
  const dispatch: any = useDispatch();
  const sharedActions = useSelector((state: any) => state.sharedActions);
  const location = useLocation();

  const isNotificationRoute = location.pathname.includes("/notifications");
  const isInvoiceRoute = location.pathname.includes("/invoice");
  const isDashboardRoute = location.pathname.includes("/dashboard");



  const handleDelete = (itemId) => {
    const values = {
      title: "Sei sicuro?",
      text: "Non sarà possibile annullare questa operazione!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sì, cancellalo!",
    };

    conFirmMessage(values).then((result) => {

      console.log(sharedActions, ">>> sharedActions")
      if (result.isConfirmed) {
        if (isNotificationRoute) {
          console.log(sharedActions?.selectedPage, " notification >>> selectedPage", user?.id)
          setTimeout(() => {
            dispatch(
              DeleteNotification({
                id: user?.id,
                selectedPage: sharedActions?.selectedPage || 1,
              })
            );
          }, 100);
        }
        else if (isInvoiceRoute) {
          console.log(sharedActions?.selectedPage, " inventory >>> selectedPage", user?.id)
          setTimeout(() => {
            dispatch(
              DeleteInvoice({
                id: user?.id,
                selectedPage: sharedActions?.selectedPage || 1,
                invoice_number: user?.invoice_number
              })
            );
          }, 100);
        }
      }
    });
  };

  const handleEdit = async (itemId) => {
    console.log('itemId >>> ', itemId);
    if (isInvoiceRoute) {
      await dispatch(setOpenEditInvoiceModal(user));
    }
  };

  // const openUserDetailsModal = () => {
  //   console.log(user.invoice_number, ">> openUserDetailsModal >>>>")
  //   dispatch(setOpenInvoiceListModal({ invoice_number: user.invoice_number }))
  // }

  const openUserDetailsModal = () => {
    let payload: any = {};

    if (user?.order_number) {
      payload = { order_number: user.order_number };
      dispatch(setOpenOrderListModal(payload));

    } else if (user?.invoice_number) {
      payload = { invoice_number: user.invoice_number };
      dispatch(setOpenInvoiceListModal(payload))
    } else {
      console.log("No order_number or invoice_number found for user", user);
      return;
    }

    console.log(payload, ">> openUserDetailsModal >>>>");

  };


const openDocumentModal = () => {
    if (!user?.invoice_number) return;

    const invoiceNumber = user.invoice_number;

    // Open the modal in view mode
    dispatch(setOpenDocumentUploadModal({ invoiceNumber, isViewMode: true }));
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <div className="menu-item me-4">
          <Dropdown className="verifiedOptions">
            <Dropdown.Toggle variant="default" id="dropdown-basic">
              <ThreeDotsIcon />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {(isNotificationRoute || isInvoiceRoute) && (isModalContext || isDashboardRoute) && (
                <Link
                  to="#"
                  className="menu-link px-3 btn justify-content-start btn-active-light-primary btn-sm"
                  onClick={async () => await handleDelete(user.id)}
                >
                  <KTIcon iconName="trash" className="fs-2 text-danger" /> Eliminare
                </Link>
              )}

              {isModalContext && (
                <Link
                  to="#"
                  className="menu-link px-3 btn justify-content-start btn-active-light-primary btn-sm"
                  onClick={async () => {
                    await handleEdit(user.id)
                  }}
                >
                  <KTIcon iconName="pencil" className="fs-2 text-warning" /> Modificare
                </Link>
              )}

              {(isNotificationRoute || isInvoiceRoute || isDashboardRoute) && !isModalContext && (
                <Link
                  to="#"
                  className="menu-link justify-content-start px-3 btn btn-active-light-primary btn-sm"
                  onClick={openUserDetailsModal}
                >
                  <KTIcon iconName="eye" className="fs-2" /> Dettagli
                </Link>
              )}

              {(isInvoiceRoute) && !isModalContext && (
                <Link
                  to="#"
                  className="menu-link justify-content-start px-3 btn btn-active-light-primary btn-sm"
                  onClick={openDocumentModal}
                >
                  <KTIcon iconName="eye" className="fs-2" />  Documents
                </Link>
              )}
            </Dropdown.Menu>


          </Dropdown>
        </div>
      </div>
    </>
  );
};

export { ActionCell };
